(function () {
    'use strict';

    // Wait for global hub client to exist
    const waitForHub = () => new Promise((resolve) => {
        if (window.notificationHub) return resolve(window.notificationHub);
        const check = () => { if (window.notificationHub) resolve(window.notificationHub); else setTimeout(check, 150); };
        check();
    });

    const init = async function () {
        const hub = await waitForHub();
        if (!hub) {
            console.warn('admin-push: notificationHub not available');
            return;
        }

        const sendBtn = document.getElementById('send');
        const sendMeBtn = document.getElementById('sendMe');
        const feedback = document.getElementById('push-feedback');

        function setFeedback(msg, isError) {
            if (!feedback) return;
            feedback.textContent = msg;
            feedback.className = isError ? 'text-danger' : 'text-success';
        }

        // enable buttons once hub connection resolves
        try {
            await hub.startPromise;
            if (sendBtn) sendBtn.disabled = false;
            if (sendMeBtn) sendMeBtn.disabled = false;
            setFeedback('Connected to notification hub.', false);
        } catch (e) {
            setFeedback('Hub connection failed.', true);
        }

        if (sendBtn) {
            sendBtn.addEventListener('click', async function () {
                const title = document.getElementById('title').value;
                const message = document.getElementById('message').value;
                const url = document.getElementById('url').value;
                try {
                    await hub.invoke('SendPushToAll', title, message, url);
                    setFeedback('Push sent (server accepted).', false);
                } catch (e) {
                    console.error('admin-push: send failed', e);
                    setFeedback('Send failed: ' + (e && e.message ? e.message : String(e)), true);
                }
            });
        }

        if (sendMeBtn) {
            sendMeBtn.addEventListener('click', async function () {
                try {
                    if (!navigator.serviceWorker) throw new Error('Service worker not available');
                    const reg = await navigator.serviceWorker.ready;
                    const sub = await reg.pushManager.getSubscription();
                    if (!sub) { setFeedback('No active subscription found in this browser.', true); return; }

                    const title = document.getElementById('title').value;
                    const message = document.getElementById('message').value;
                    const url = document.getElementById('url').value;

                    const ok = await hub.invoke('SendPushToSubscription', sub.toJSON(), title, message, url);
                    if (ok) setFeedback('Push sent to this client (server accepted).', false);
                    else setFeedback('Server failed to send to that subscription.', true);
                } catch (e) {
                    console.error('admin-push: send-to-me failed', e);
                    setFeedback('Send-to-me failed: ' + (e && e.message ? e.message : String(e)), true);
                }
            });
        }
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
